/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { isEmpty, isEqual, throttle } from 'lodash';

// Components
import AffectedUsers from 'shared/ui/components/form-components/targeting/AffectedUsers.vue';
import Badge from 'shared/ui/components/Badge.vue';
import PersonTarget from 'shared/ui/components/form-components/targeting/PersonTarget.vue';

const __vue_script__ = {
    name: 'TargetingContent',

    components: { Badge, PersonTarget },

    props: {
        eventId: {
            type: String,
            required: true
        },

        value: {
            type: Object,
            default() {
                return {
                    targets: [],
                    exceptions: []
                };
            }
        },

        visibleToLabel: {
            type: String,
            default: null
        },

        hiddenToLabel: {
            type: String,
            default: null
        },

        visibleToDesc: {
            type: String,
            default: null
        },

        hiddenToDesc: {
            type: String,
            default: null
        },

        additionalFields: {
            type: Array,
            default: () => [],
        },

        fieldValuesToRemove: {
            type: Object,
            default: () => {}
        },

        showTargets: {
            type: Boolean,
            default: true
        },

        showExceptions: {
            type: Boolean,
            default: true
        },

        showAffectedPaxBtn: {
            type: Boolean,
            default: true
        },

        noTargetingBehavior: {
            type: String,
            default: 'show-all'
        }
    },

    data() {
        return {
            abortController: new AbortController(),
            affectedUsers: { pax: [], count: 0 },
            debounced: false,
            mutex: null,
            targets: this.value?.targets || [],
            exceptions: this.value?.exceptions || []
        };
    },

    computed: {
        /** @returns {boolean} */
        hasRules() {
            return Boolean(this.targets.length || this.exceptions.length);
        },
    },

    watch: {
        // Keep local state in sync when the parent updates the v-model value later
        value: {
            deep: true,
            handler(newVal, oldVal) {
                if (isEqual(oldVal, newVal)) {
                    return;
                }

                this.targets = newVal?.targets || [];
                this.exceptions = newVal?.exceptions || [];
                this.loadAffectedUsers?.();
            }
        }
    },

    created() {
        this.loadAffectedUsers = throttle(this.loadAffectedUsersUnthrottled.bind(this), 3000);
        this.loadAffectedUsers();
    },

    beforeDestroy() {
        this.abortController.abort('component_destroy');
    },

    methods: {
        /**
         * Displays a list of affected users
         */
        async loadAffectedUsersUnthrottled() {
            try {
                if (this.mutex || !this.showAffectedPaxBtn) {
                    console.info('[TargetingContent] Debouncing users preview...');
                    this.debounced = true;
                    return;
                }

                this.mutex = true;

                const { targets, exceptions } = this;

                if (this.noTargetingBehavior === 'no-one' && isEmpty(targets)) {
                    this.affectedUsers = { pax: [], count: 0 };
                    this.mutex = false;
                    return;
                }

                const jobId = await this.$services.user.getAffectedUsersPreview(this.eventId, { targets, exceptions }, this.abortController.signal);

                // If no job id, it means the computation was already asked but not started
                if (jobId) {
                // No async here as we don't actually want to block the UI while waiting for the job to be done.
                    this.$services.jobs.waitFor({ jobId,
                        statusPath: this.$const.QUEUE_JOB_STATUS_PATH.replace('{{jobId}}', jobId.toString()),
                        resultPath: this.$const.QUEUE_JOB_RESULT_PATH.replace('{{jobId}}', jobId.toString())
                    }).then(data => {
                        this.affectedUsers = data.results;
                    }).finally(() => {
                        this.mutex = false;
                    });
                }

                if (this.debounced) {
                    console.info('[TargetingContent] Loading with latest updates');
                    this.debounced = false;
                    this.loadAffectedUsers(true);
                }

            } catch (error) {
                console.error('[TargetingContent] Unable to load targeted users:', error.message);
                this.mutex = false;
            }
        },

        /**
         * Emits the targeting configuration
         */
        emit() {
            const { targets, exceptions } = this;
            this.$emit('input', { targets, exceptions });
        },

        /**
         * Shows the affected users modal
         */
        async showAffectedPax() {
            if (!this.hasRules) {
                return;
            }

            if (!this.affectedUsers || !this.affectedUsers.pax.length) {
                return;
            }
            this.$modal.show(AffectedUsers, {
                count: this.affectedUsers.count,
                users: this.affectedUsers.pax,
            },
            {
                classes: 'small',
                height: 'auto',
                reset: true
            });
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"targeting-content"},[(_vm.showTargets)?_c('person-target',{staticClass:"visible-to",attrs:{"event-id":_vm.eventId,"additional-fields":_vm.additionalFields,"field-values-to-remove":_vm.fieldValuesToRemove},on:{"change":function($event){return _vm.emit()}},scopedSlots:_vm._u([{key:"header",fn:function(ref){
var values = ref.values;
var addRule = ref.addRule;
return [_c('legend',[_c('i',{staticClass:"ic-eye"}),_vm._v(_vm._s(_vm.visibleToLabel || _vm.$t('targeting.conditions_editor.visible_to'))),(values.length)?_c('badge',{staticClass:"success"},[_vm._v(_vm._s(values.length))]):_vm._e()],1),_c('p',{staticClass:"description"},[_vm._v(_vm._s(_vm.visibleToDesc || _vm.$t('targeting.conditions_editor.text_for_visible_to')))]),_c('a',{staticClass:"has-action",on:{"click":function($event){return addRule()}}},[_vm._v(_vm._s(_vm.$t('targeting.conditions_editor.add_rule')))])]}}],null,false,2914774393),model:{value:(_vm.targets),callback:function ($$v) {_vm.targets=$$v},expression:"targets"}}):_vm._e(),(_vm.showExceptions)?_c('person-target',{staticClass:"hidden-to",attrs:{"event-id":_vm.eventId,"additional-fields":_vm.additionalFields,"field-values-to-remove":_vm.fieldValuesToRemove},on:{"change":function($event){return _vm.emit()}},scopedSlots:_vm._u([{key:"header",fn:function(ref){
var values = ref.values;
var addRule = ref.addRule;
return [_c('legend',[_c('i',{staticClass:"ic-eye-off"}),_vm._v(_vm._s(_vm.hiddenToLabel || _vm.$t('targeting.conditions_editor.hidden_to'))),(values.length)?_c('badge',{staticClass:"danger"},[_vm._v(_vm._s(values.length))]):_vm._e()],1),_c('p',{staticClass:"description"},[_vm._v(_vm._s(_vm.hiddenToDesc || _vm.$t('targeting.conditions_editor.text_for_hidden_to')))]),_c('a',{staticClass:"has-action",on:{"click":function($event){return addRule()}}},[_vm._v(_vm._s(_vm.$t('targeting.conditions_editor.add_rule')))])]}}],null,false,29163395),model:{value:(_vm.exceptions),callback:function ($$v) {_vm.exceptions=$$v},expression:"exceptions"}}):_vm._e(),(_vm.affectedUsers.error)?_c('section',{staticClass:"targeting-errors"},[_c('h3',[_vm._v(_vm._s(_vm.$t('targeting.conditions_editor.targeting_has_errors'))+":")]),_vm._l((_vm.affectedUsers.error),function(error){return _c('p',[_vm._v(_vm._s(error))])})],2):_vm._e(),(_vm.showAffectedPaxBtn)?_c('a',{staticClass:"affected-users has-action",attrs:{"disabled":_vm.affectedUsers.count === 0},on:{"click":_vm.showAffectedPax}},[_vm._v(_vm._s(_vm.$t('targeting.conditions_editor.show_affected', [_vm.affectedUsers.count]))),_c('i',{staticClass:"ic-open"}),(_vm.mutex)?_c('loader',{staticClass:"in-page small static inline",attrs:{"status":_vm.mutex}}):_vm._e()],1):_vm._e()],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "TargetingContent.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__